import { upvoteReview } from './fetches/powerReviews'
import styles from './reviewSection.module.scss'

import { useState } from 'react'

import classNames from 'classnames'
import Image from 'next/image'

import { createClickedSegmentEvent } from 'Clutch/Utilities/Instrumentation/Impressions/impressionSegmentEvents'

import Carousel from 'Clutch/Organisms/Carousel'

import Area from 'Clutch/Molecules/Area'
import Button from 'Clutch/Molecules/Button'

import Card from 'Clutch/Atoms/Card'
import Panel from 'Clutch/Atoms/Panel'
import Rating from 'Clutch/Atoms/Rating'
import Svg from 'Clutch/Atoms/Svg'
import Typography from 'Clutch/Atoms/Typography'

const ReviewCard = ({ condensed = false, titleOverride, reviewData, powerReviewsApiKey, powerReviewsMerchantId }) => {
  if (!reviewData) return false

  return (
    <Card fill>
      <Typography font="bold" size="0.875" className={styles.marginBottom}>
        {titleOverride ?? reviewData.details.headline}
      </Typography>
      <div className={classNames(styles.inline, styles.marginBottom)}>
        <Rating ratingValue={reviewData?.rating ?? reviewData.metrics?.rating} />
        <Typography font="bold" size="0.75">
          {reviewData?.rating ?? reviewData.metrics?.rating}.0
        </Typography>
        {!condensed && (
          <Typography tone="subtle" size="0.75">
            {reviewData.details.time_ago_string}
          </Typography>
        )}
      </div>
      {condensed && (
        <div className={classNames(styles.inline, styles.marginBottom)}>
          <Typography font="bold" size="0.875">
            {reviewData.headline}
          </Typography>
        </div>
      )}
      {!condensed && (
        <div className={classNames(styles.inline, styles.marginBottom)}>
          <Typography font="bold" tone="subtle" size="0.75">
            {reviewData.details.nickname}
          </Typography>
          <Typography tone="subtle" size="0.75">
            {reviewData.details.location}
          </Typography>
          {(reviewData.badges.is_verified_reviewer || reviewData.badges.is_verified_buyer) && <VerifiedBadge />}
        </div>
      )}
      <Typography size="1" className={styles.marginBottom}>
        {reviewData.comments ?? reviewData.details?.comments}
      </Typography>
      {!condensed && reviewData.details?.bottom_line && <BottomLine bottomLine={reviewData.details.bottom_line} />}
      {!condensed && reviewData.media.length > 0 && (
        <div>
          <Carousel id={`${reviewData.ugc_id}-media`} leftAlignCarousel>
            {reviewData.media.map(
              (item, i) =>
                !item.uri.includes('youtube') && (
                  <Carousel.Item key={`review_media_${reviewData.ugc_id}_${i}`}>
                    <Image
                      src={`https:${item.uri}`}
                      height={88}
                      width={88}
                      alt={'Customer review image'}
                      sizes={'96px'}
                      className={styles.image_contain}
                      onClick={() => {
                        if (item.type === 'image') {
                          window.open(`https:${item.uri}`, '_blank')
                        } else {
                          window.open(item.uri, '_blank')
                        }
                      }}
                    />
                  </Carousel.Item>
                ),
            )}
          </Carousel>
        </div>
      )}
      {!condensed && (
        <div>
          <HelpfulButton
            ugcId={reviewData.ugc_id}
            helpfulVotes={reviewData.metrics.helpful_votes}
            powerReviewsMerchantId={powerReviewsMerchantId}
            powerReviewsApiKey={powerReviewsApiKey}
          />
        </div>
      )}
    </Card>
  )
}

const HelpfulButton = ({ ugcId, helpfulVotes, powerReviewsMerchantId, powerReviewsApiKey }) => {
  const [voted, setVoted] = useState(false)

  if (!ugcId || !powerReviewsMerchantId || !powerReviewsApiKey) return false

  return (
    <Panel layer={0}>
      <div disabledbool={voted.toString()} className={styles.helpfulButtonWrapper}>
        <Button
          intent={'subdued'}
          segmentEvent={createClickedSegmentEvent('ReviewUpvote')}
          size={'small'}
          className={classNames(styles.inline, styles.helpfulButton)}
          disabled={voted}
          onClick={() => {
            setVoted(true)
            //upvoteReview(ugcId, powerReviewsMerchantId, powerReviewsApiKey)
          }}
        >
          <Svg size={0.875} icon={'thumb_up'} brand={'secondarypalette_black'} />
          <Typography size={0.875} font={'bold'}>
            Helpful ({voted ? helpfulVotes + 1 : helpfulVotes})
          </Typography>
        </Button>
      </div>
    </Panel>
  )
}

const VerifiedBadge = () => {
  return (
    <Area intent="positive" noPadding fitContent>
      <div className={styles.inline}>
        <Svg size="0.75" intent="positive" icon="check" />
        <Typography font="bold" size="0.75">
          Verified
        </Typography>
      </div>
    </Area>
  )
}

const BottomLine = ({ bottomLine }) => {
  if (bottomLine === 'Yes') {
    return (
      <div className={classNames(styles.inline, styles.marginBottom)}>
        <Svg size="0.75" intent="positive" icon="check" />
        <Typography font="bold" size="0.75">
          Would Recommend
        </Typography>
      </div>
    )
  }
  if (bottomLine === 'No') {
    return (
      <div className={classNames(styles.inline, styles.marginBottom)}>
        <Svg size="0.75" tone="subtle" icon="unavailable" />
        <Typography font="bold" size="0.75">
          Would Not Recommend
        </Typography>
      </div>
    )
  }
}

export default ReviewCard
